<template>
  <div style="background: #f5f5f5;" ref="container">
    <!-- <el-row> -->
    <!-- <el-col :sm="4" :md="4" :lg="4" :xl="4" style="min-height:10px"><div class="clearfix"></div></el-col> -->
    <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" style="box-sizing: border-box;float: none;margin: 0 auto;"> -->
    <!-- <el-col :sm="15" :md="15" :lg="15" :xl="16" style="box-sizing: border-box;"> -->
    <div class="warp_container clearfix">
      <div class="course_about clearfix div_bg">
        <div class="about_top">
          <!-- <router-link :to="{ path: '/' }">首页</router-link>
          <router-link :to="{ path: '/courselist' }">课程</router-link>
          {{ course.course_name }} -->
        </div>
        <div class="about_conter">
          <div class="conter_left"><img :src="course.course_img" alt="" /></div>
          <div class="conter_right">
            <div class="conter_txt1">{{ course.course_name }}</div>
            <div class="conter_txt2">{{ course.course_subtitle }}</div>
            <div class="couter_student_num">
              <span class="couter_icon">精选</span>
              <span>{{ course.course_buy_num }}人正在学习</span>
            </div>
            <div style="padding-right:30px;" v-if="(course.user_status == -1||course.user_status==2)">
              <div class="conter_price">
                <span class="font_txt">价 格</span>
                <span class="price_num"
                  >￥{{ course.course_discount_price }}</span
                >
                <span class="origin_price"
                  >原价:<del>￥{{ course.course_origin_price }}</del></span
                >
              </div>
            </div>
            <!-- <div class="conter_time"><span class="font_txt">开课时间</span><span>{{course.course_created_time}}</span></div> -->
            <div
              v-if="
                (course.user_status === -1||course.user_status==2) && course.course_discount_price > 0
              "
              class="shop_btn"
              @click="buy"
            >
              立即购买
            </div>
            <div
              v-if="
                (course.user_status === -1||course.user_status==2) && course.course_discount_price === 0
              "
              class="shop_btn"
              @click="buy"
            >
              免费观看
            </div>
            <!-- <div class="shop_btn" @click="buy">立即购买</div> -->
          </div>
        </div>
      </div>
      <div class="main_warp">
        <div class="main_left div_bg">
          <div class="main_nav" ref="nav_box">
            <ul class="border_btm">
              <li>
                <a @click="nav1($event)" :class="{ broder_btm: isselect1 }"
                  >课程详情</a
                >
              </li>
              <li>
                <a @click="nav2($event)" :class="{ broder_btm: isselect2 }"
                  >课程表</a
                >
              </li>
              <!-- <li><a @click="nav3($event)" :class="{'broder_btm':isselect3}">推荐课程</a></li> -->
            </ul>
          </div>
          <div>
            <div class="xq border_btm" id="nav1" ref="nav1">
              <p class="one_title">课程详情</p>
              <div
                class="imgbox"
                style="max-width:100%;box-sizing: border-box;"
                v-html="
                  course.course_details
                    ? strcharacterDiscode(course.course_details)
                    : ''
                "
              ></div>
              <!-- <img src="../assets/jjj.jpg" alt=""> -->
            </div>
            <div class="border_btm" id="nav2" ref="nav2">
              <p class="one_title">课程表</p>
              <ul style="padding-left:0;">
                <li
                  v-for="(val, key) in lesson"
                  :key="key"
                  class="lesson_li"
                  @click="demand(key, val.lesson_id)"
                >
                  <div class="kc_left">
                    <span class="kc_left_icon">{{ key + 1 }}</span>
                    <div style="display: inline-block">
                      <div class="live_list_txt">
                        <span>{{ val.lesson_name }}</span>
                        <span
                          v-if="val.is_free !== 0 && (course.user_status === -1||course.user_status==2)"
                          class="free_course_tips"
                          >试听</span
                        >
                      </div>
                      <div
                        class="live_list_time"
                        v-if="val.lesson_type === 'live'"
                      >
                        {{ val.lesson_start_time_date }} ~
                        {{ val.lesson_end_time_date }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <span
                      v-if="val.has_course_ware === 1 && val.user_is_download_count > 0"
                      @click.stop="showWareList(val.lesson_id)"
                      class="kc_right kc_right_ware"
                      >下载课件</span
                    >
                    <span class="kc_right">{{
                      val.lesson_status_now_text
                    }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 课件弹窗 -->
    <div class="cover" v-if="showWare" @click="showWareList('')"></div>
    <div class="ware_list_content" v-if="showWare">
      <div class="ware_list_title">
        <span></span>
        <span>课件详情</span>
        <i @click="showWareList('')" class="el-icon-error"></i>
      </div>
      <div class="ware_list_group">
        <div
          class="ware_list_box"
          v-for="(item, index) in courseWareList"
          :key="index"
        >
          <div class="ware_list_dec">
            <span>{{ index + 1 }}.{{ item.file_name }}</span>
            <div
              v-if="item.is_download != 1"
              @click="previewWare(item)"
              class="ware_list_btn"
              :class="{
                ware_list_btn_active:
                  (item.is_download == 2 && course.user_status == 1) ||
                  item.is_download == 3
              }"
            >
              下载
            </div>
            <div v-else class="ware_list_txt">该课件暂无下载</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible"
      width="280px"
      center
      class="overdue_dialog"
    >
      <div class="overdue_dialog_title">该课程已过期，重新购买课程可继续观看</div>
      <div slot="footer" class="overdue-dialog-footer">
        <div class="overdue_dialog_btn" @click="succeed">确定</div>
        <div class="overdue_dialog_btn overdue_f_btn" @click="fail">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from "../store";
import strcharacterDiscode from "@/js/strcharacterDiscode";
export default {
  inject: ["reload"],
  data() {
    return {
      page: 1,
      isOnScroll: false,
      course: "",
      lesson: "",
      lesson_id:'',
      courseData: "",
      topCourse: "",
      isselect1: true,
      isselect2: false,
      isselect3: false,
      nav_height: "",
      showWare: false,
      courseWareList: [],
      centerDialogVisible: false
    };
  },
  methods: {
    strcharacterDiscode,
    getData() {
      //获取课程、课时
      this.$http
        .get("/api/v2/course/getCourseLesson", {
          params: {
            course_id: this.$route.params.course_id
          },
          headers: {
            token: localStorage.getItem("token")
              ? localStorage.getItem("token")
              : "" //自定义请求头信息
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.course = res.data.data.course;
            this.lesson = res.data.data.lesson;
            this.$changeTitle(res.data.data.course.course_name + "--");
            this.nav_height = this.$refs.nav_box.offsetTop;
          } else if (res.data.code === 0) {
            this.$message({
              message: res.data.msg,
              showClose: true
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTopCourse() {
      //获取推荐课程
      this.$http
        .get("/api/v2/course/getTopCourse", {
          params: {
            limit: 3
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.topCourse = res.data.data;
          } else if (res.data.code === 0) {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    nav1(e) {
      this.isselect1 = true;
      this.isselect3 = false;
      this.isselect2 = false;
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.nav1.offsetTop;
      // !!document.querySelector("#nav1") &&
      //   document.querySelector("#nav1").scrollIntoView(true);
    },
    nav2(e) {
      this.isselect2 = true;
      this.isselect1 = false;
      this.isselect3 = false;
      document.body.scrollTop = document.documentElement.scrollTop =
        this.$refs.nav2.offsetTop - 95;
      // !!document.querySelector("#nav2") &&
      //   document.querySelector("#nav2").scrollIntoView(true);
    },
    nav3(e) {
      this.isselect1 = false;
      this.isselect2 = false;
      this.isselect3 = true;
      !!document.querySelector("#nav3") &&
        document.querySelector("#nav3").scrollIntoView(true);
    },
    // 购买课程
    buy() {
      this.$router.push({
        name: "submitOrder",
        params: { course_id: this.$route.params.course_id }
      });
    },
    // 跳转下载
    toDownload(url) {
      window.open();
    },
    // 跳转点播
    demand(index, id) {
      if(this.course.user_status==2) {
        this.centerDialogVisible = true
        return false;
      }
      if (localStorage.getItem("token")) {
        if (
          this.lesson[index].lesson_type === "video" ||
          this.lesson[index].lesson_type === "playback"
        ) {
          localStorage.setItem("lessonID", this.lesson[index].lesson_id);
          this.$router.push({
            path: "/demand",
            query: {
              lesson_id: this.lesson[index].lesson_id,
              course_id: this.course.course_id
            }
          });
        } else if (
          this.lesson[index].lesson_type === "live" &&
          this.lesson[index].lesson_status_now === 1
        ) {
          // var fls = this.flashChecker();
          // if (!fls.f) {
          //   if (
          //     confirm(
          //       "您的浏览器未安装Flash插件导致无法播放，建议使用QQ浏览器和360浏览器等，或者现在安装Flash插件？"
          //     )
          //   ) {
          //     window.location.href = "http://www.flash.cn";
          //   }
          //   return;
          // }
          this.$router.push({
            path: "/live",
            query: { course_id: this.course.course_id, lesson_id: id }
          });
        } else if (
          this.lesson[index].lesson_type === "live" &&
          this.lesson[index].lesson_status_now === 2
        ) {
          this.$message({
            message: "直播已结束",
            showClose: true
          });
        } else if (
          this.lesson[index].lesson_type === "live" &&
          this.lesson[index].lesson_status_now === 0
        ) {
          this.$message({
            message: "直播未开始",
            showClose: true
          });
        }
      } else {
        store.commit("setDialogLogin", true);
      }
    },
    toCourse(index) {
      this.$router.push({
        name: "courseDescription",
        params: { course_id: this.topCourse[index].course_id }
      });
      this.reload();
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var ele = this.$refs.nav_box,
        elew;

      if (this.$refs.nav_box.offsetTop > 0) {
        this.nav_height = this.$refs.nav_box.offsetTop;
        elew = this.$refs.nav_box.offsetWidth;
      }

      // if(scrollTop>this.nav_height+ele.offsetHeight*2){
      if (scrollTop > this.nav_height) {
        ele.style.position = "fixed";
        ele.style.top = 0;
        ele.style.zIndex = 2;
        ele.style.background = "#ffffff";
        ele.style.width = elew + "px";
      } else {
        ele.style = "";
      }
    },
    flashChecker() {
      var hasFlash = 0; //是否安装了flash
      var flashVersion = 0; //flash版本
      if (document.all) {
        var swf = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
        if (swf) {
          hasFlash = 1;
          VSwf = swf.GetVariable("$version");
          flashVersion = parseInt(VSwf.split(" ")[1].split(",")[0]);
        }
      } else {
        console.log(navigator);
        if (navigator.plugins && navigator.plugins.length > 0) {
          var swf = navigator.plugins["Shockwave Flash"];
          if (swf) {
            hasFlash = 1;
            var words = swf.description.split(" ");
            for (var i = 0; i < words.length; ++i) {
              if (isNaN(parseInt(words[i]))) continue;
              flashVersion = parseInt(words[i]);
            }
          }
        }
      }
      return { f: hasFlash, v: flashVersion };
    },
    // 显示课件列表
    showWareList(id, page = 1) {
      this.lesson_id = id;
      if (id) {
        document.body.style.overflow = "hidden";
        let d = {
          lesson_id: id,
          page
        };
        this.$http
          .get("/api/v2/course_ware/getCourseWareListByLesson", {
            params: d,
            headers: {
              token: localStorage.getItem("token")
                ? localStorage.getItem("token")
                : "" //自定义请求头信息
            }
          })
          .then(res => {
            if (res.data.code == 1) {
              let d = res.data.data.data
              if(d.length > 0 && this.page == 1){
              this.courseWareList = res.data.data.data;
              }else if(d.length > 0 && this.page > 1){
                this.courseWareList = this.courseWareList.concat(d)
              }else if(d.length == 0 && this.page > 1){
                this.page = --this.page;
                this.$message({ message: "已经到底了" });
              }
              if (this.courseWareList.length > 0) {
                this.showWare = true;
                document.body.style.overflow = "hidden";
                if (!this.isOnScroll) {
                  setTimeout(() => {
                    this.isOnScroll = true
                    let group = document.querySelector(".ware_list_group");
                    group.addEventListener("scroll", e => {
                      var scrollHeight = e.target.scrollHeight;
                      var scrollTop = e.target.scrollTop;
                      var height = e.target.offsetHeight;
                      if (scrollTop + height == scrollHeight) {
                        this.page = ++this.page;
                        console.log(this.page)
                        group.onscroll = null;
                        this.showWareList(this.lesson_id,this.page);
                      }
                    });
                  }, 300);
                }
              } else {
                this.$message({ message: "暂时没有课件" });
              }
            }
          });
      } else {
        this.showWare = false;
        this.isOnScroll = false;
        this.courseWareList = [];
        this.page = 1;
        document.body.style.overflow = "auto";
      }
    },
    // 预览课件
    previewWare(item) {
      if(item.is_download == 2 && this.course.user_status != 1){
        this.$message({message:'需要购买才能观看该课件'})
        return
      }
      if (
        (item.is_download == 2 && this.course.user_status == 1) ||
        item.is_download == 3
      ) {
        let etx = item.url_path.split('.')
        etx = etx[etx.length - 1];
        console.log(etx);
        if(etx == 'pdf' || etx == 'txt'){
          window.open(item.url_path);
        }else{
          window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.url_path}`)
        }
      }
    },
    succeed() {
      this.$router.push({
        name: "submitOrder",
        params: { course_id: this.$route.params.course_id }
      });
      this.centerDialogVisible=false
    },
    fail() {
      this.centerDialogVisible=false
    }
  },
  created() {
    this.getData();
    //this.getTopCourse();
    store.commit("setNav", null);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    //     var appdom=document.querySelector("#app").offsetHeight;
    //     var hdom=document.querySelector(".header").offsetHeight;
    //     var fdom=document.querySelector(".footer").offsetHeight;
    //     var cdom=this.$refs.container.offsetHeight;

    //     // console.log(this.$refs.container.offsetHeight,99)
    //     if(hdom+cdom>appdom-fdom){
    //         document.querySelector(".footer").style='';
    //         alert(1)
    //     }else{
    //         document.querySelector(".footer").style.position="fixed";
    //         document.querySelector(".footer").style.bottom=0;
    //         alert(2)
    //     }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.course_about {
  padding-left: 30px;
  padding-bottom: 60px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.about_top {
  font-size: 14px;
  color: #999999;
  height: 60px;
  line-height: 60px;
}
.about_conter {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}
.conter_left,
.conter_right {
  float: left;
}
.conter_left {
  width: 540px;
  height: 330px;
  border-radius: 20px;
}
.conter_left img {
  width: 100%;
  height: 100%;
  box-shadow: 0px 2px 8px 2px rgba(50, 51, 51, 0.2);
  border-radius: 15px;
}
.conter_right {
  color: #333333;
  font-family: Microsoft YaHei;
  font-size: 14px;
  position: relative;
  width: 54%;
  box-sizing: border-box;
  padding-left: 30px;
}
.conter_txt1 {
  font-size: 24px;
  color: #333333;
  font-family: "Microsoft YaHei";
}
.conter_txt2 {
  font-size: 14px;
  margin: 30px 0;
}
.conter_price {
  display: flex;
  align-items: center;
  height: 68px;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 35px;
  padding-left: 15px;
}
/* .conter_price span{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    } */
.font_txt {
  font-size: 14px;
  color: #999999;
  margin-right: 18px;
}
.price_num {
  color: #ff6029;
  font-size: 24px;
  margin-right: 20px;
  /* left: 60px; */
}
.origin_price {
  position: relative;
  top: 2px;
  margin-left: 3px;
  color: #9d9d9e;
}
.conter_time {
  margin-top: 30px;
}
.shop_btn {
  width: 150px;
  height: 50px;
  background: linear-gradient(
    30deg,
    rgba(255, 142, 2, 1),
    rgba(255, 111, 2, 1)
  );
  border-radius: 25px;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  font-size: 20px;
  margin-top: 20px;
  cursor: pointer;
}
/* 课程详情介绍块 */
.main_warp {
  width: 100%;
  box-sizing: border-box;
}
.main_left {
  width: 100%;
  box-sizing: border-box;
  margin-right: 0;
  margin-bottom: 30px;
}
.main_left,
.main_right {
  float: left;
}
.main_right {
  width: 30%;
  padding-left: 20px;
  box-sizing: border-box;
}
.main_nav ul {
  margin: 0;
  height: 60px;
  padding: 0 30px;
}
.main_nav ul li {
  font-size: 18px;
  float: left;
  width: 25%;
}
.main_nav ul li a {
  line-height: 55px;
  height: 55px;
  font-size: 18px;
  text-align: center;
  display: inline-block;
}
.one_title {
  font-size: 20px;
  margin: 40px 0;
  padding-left: 10px;
  border-left: 5px solid #00c590;
}
.border_btm {
  border-bottom: 1px solid #cccccc;
  padding: 0 30px 40px;
}
.kc_left {
  display: flex;
  align-items: center;
}
.live_list_txt {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333333;
  margin-bottom: 6px;
}
.free_course_tips {
  margin-left: 20px;
  display: inline;
  box-sizing: border-box;
  padding: 1px 5px;
  border: 1px solid #ff6f02;
  color: #ff6f02;
  font-size: 14px;
}
.live_list_time {
  font-size: 12px;
  color: #999999;
}
.kc_right {
  display: inline-block;
  width: 100px;
  font-size: 14px;
  color: #999;
  text-align: right;
}
.kc_right:hover {
  color: #00c590 !important;
}
.kc_right_ware {
}
.kc_left_icon {
  width: 20px;
  height: 20px;
  background: #00c590;
  color: #ffffff;
  border-radius: 50%;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  display: inline-block;
  margin-right: 10px;
}
.tijian_box {
  width: 100%;
  box-sizing: border-box;
}
.tijian {
  width: 31.6%;
  box-shadow: 0px 1px 8px 2px rgba(50, 51, 51, 0.2);
  border-radius: 10px;
  display: inline-block;
  box-sizing: border-box;
}
.tijian:nth-child(3n-1) {
  margin: 0 2.6%;
}
.tijian img {
  width: 100%;
  height: 140px;
  /* background: #841456; */
  box-shadow: 0px 1px 8px 2px rgba(84, 85, 85, 0.2);
  border-radius: 10px 10px 0 0;
}
.tijian_title {
  padding: 8px 10px;
}
.tijian_txt_top {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.tijian_time {
  font-size: 12px;
  color: #999999;
}
.tijian_price {
  font-size: 20px;
  color: #ff6029;
  position: absolute;
  right: 0;
  top: 0;
}
.tijian_txt {
  font-size: 16px;
  color: #333333;
  width: 100%;
  padding-right: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}
.live_details {
  width: 100%;
  min-height: 400px;
  margin-bottom: 20px;
}
.live_top {
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  font-size: 18px;
}
.live_conter {
  padding: 0 30px;
}
.sculpture {
  width: 70px;
  height: 70px;
  margin: 20px auto;
  background: #df8;
  border-radius: 50%;
}
.live_txt {
  text-align: center;
  border-bottom: 1px solid #00c590;
  padding-bottom: 10px;
}
.live_txt div {
  font-size: 18px;
  margin-bottom: 20px;
  color: #333;
}
.live_txt span {
  color: #00c590;
  font-size: 14px;
  text-align: center;
}
.live_conter p {
  font-size: 14px;
  color: #999999;
}
.div_bg {
  background: #fff;
}
.broder_btm {
  border-bottom: 5px solid #00c590;
}
/* .lesson_li div:hover,.main_nav li a:hover{
        color: #00C590 !important;
        cursor: pointer;
    } */
.lesson_li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  margin-bottom: 20px !important;
}
.lesson_li:last-of-type {
  border-width: 0;
}
.lesson_li:hover div {
  /* color: #00c590 !important; */
  cursor: pointer;
}
.main_nav li a:hover {
  color: #00c590 !important;
  cursor: pointer;
  border-bottom: 5px solid #00c590;
}
.couter_student_num {
  display: flex;
  align-items: center;
  margin-bottom: 34px;
  color: #666666;
}
.couter_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 25px;
  background: #ff6f02;
  color: #ffffff;
  font-size: 12px;
  margin-right: 21px;
}

/* 课件弹窗 */
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 998;
}
.ware_list_content {
  width: 800px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: #fff;
  z-index: 999;
  border-radius: 10px;
  padding: 0 10px;
  overflow: hidden;
}
.ware_list_title {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e7e7e7;
}
.ware_list_title i {
  font-size: 30px;
}
.ware_list_title i:hover {
  color: #00c590;
  cursor: pointer;
}
.ware_list_group {
  min-height: 300px;
  max-height: 565px;
  overflow: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.ware_list_group::-webkit-scrollbar {
  display: none;
}
.ware_list_box {
  height: 70px;
  border-bottom: 1px solid #e7e7e7;
}
.ware_list_dec {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.ware_list_dec span{
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.ware_list_btn {
  padding: 8px 15px;
  background: #ccc;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.ware_list_txt{
  color: #ccc;
  font-size: 14px;
}
.ware_list_btn_active {
  background: #00c590;
}
</style>
<style>
.imgbox img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/CourseDescription.vue